export const LIST = "REJECT_REASON_LIST";
export const DROPDOWN = "REJECT_REASON_DROPDOWN";
export const STORE = "REJECT_REASON_STORE";
export const DETAILS = "REJECT_REASON_DETAILS";
export const UPDATE = "REJECT_REASON_UPDATE";
export const DELETE = "REJECT_REASON_DELETE";
